export default {
  methods: {
    debounce: function(fn, delay) {
      let timeoutID = null
      return function () {
        clearTimeout(timeoutID)
        let args = arguments
        timeoutID = setTimeout(() => {
          fn.apply(this, args)
        }, delay)
      }
    }
  }
}
